import { forwardRef } from 'react';

import { cn } from '@lyearn/style';
import { Box, Stack, StackProps } from '@lyearn/ui';
import {
  iconPickerButtonStyles,
  iconPickerStaticButtonStyles,
} from '@/components/IconPicker/styles';
import { IconSettingsInput } from '@/types/schema';
import { bgColor } from '@/utils/styles';

import { ICON_SETTINGS_COLOR_PICKER_COLOR_CONFIG } from '../consts';
import { IconSettingsColorPickerColorConfig } from '../types';

interface Props extends StackProps {
  colorConfig?: IconSettingsColorPickerColorConfig;
  value: IconSettingsInput;
}

const IconSettingsColorPickerButton = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const {
    colorConfig = ICON_SETTINGS_COLOR_PICKER_COLOR_CONFIG,
    className,
    value,
    onClick,
    ...rest
  } = props;

  const colors = colorConfig[value.value].color;

  return (
    <Stack
      ref={ref}
      className={cn(
        'w-fit rounded-8 p-6',
        onClick ? iconPickerButtonStyles(colors) : iconPickerStaticButtonStyles(colors),
        className,
      )}
      role={onClick ? 'button' : 'presentation'}
      onClick={onClick}
      {...rest}>
      <Box className={cn('h-20 w-20 rounded-full', bgColor(value.value))} />
    </Stack>
  );
});

export default IconSettingsColorPickerButton;
